import {
    Feature, Process, Tutorial, Screenshots, Pricing, Video, Testimonials,
    Blog, About, Hero, Groups, Breaker, ImageBlock, Title, TeamProfile,BoxContent,ContentSection
} from "../components";
import { React, useEffect, useState } from "react";
import createClient from '../Client';
import Contact from "../components/Contact";
import BoxContentNotGroup from "../components/BoxContentNotGroup";
import Loader from "../components/Loader";
import { NewsSinglePost, Header, Footer } from "../components";


//Home page
const Home = ({ setLoading, footerData, items }) => {
    const [homeBlockData, setHomeBlockData] = useState([]);
    const boxContentData = [];
    let renderedBoxContent = false;
    const [loadingHome, setLoadingHome] = useState(true);
    const [heroDataLoaded, setHeroDataLoaded] = useState(false);
    //   const [loading, setLoading] = useState(true);

    //   useEffect(() => {
    //           setTimeout(() => {
    //               setLoading(false);
    //           }, 400);
    //       }, []);

    useEffect(() => {
        setLoading(true); // Set global loading to true when Home mounts
        createClient.fetch(`*[_type == "home"][0].moduleBlock[] {
            ...,
            _type == "gallery" => {
                ...,
                "imageUrl": images[].asset -> url
            },
            _type == "video" => {
                "imageUrl": video_thumbnail_image.asset -> url
            },
            _type == "cc_box_content" => {
                        "boxSectiontitle": cc_box_content_title,
                        "boxSectioncontent": cc_box_content_content,
                        "boxSectionwidth": cc_box_content_width,
                        "boxSectionalignment": cc_box_content_alignment,
                        "imageUrl": cc_box_content_images[].asset->url
                        },
            _type == "cc_img_section" => {
                "imageUrl": cc_img.asset -> url
            },
            _type == "tutorial" => {
                groups[] {
                ...,
                "imageUrl": tutorialGroup_img.asset -> url
                }
            },
            _type == "reference"=> {
                ...,
                'slug': @-> page_slug.current,
                "aboutImage": @-> page_featured_image.asset -> url,
                "aboutTitle": @-> page_title,
                "aboutSubTitle": @-> page_sub_title,
                "aboutDes" : @-> page_content,
                "aboutDesHTML" : @-> page_content_html,
                "template": @-> sel_page_template,
            },
            _type == "group" => {
                ...,
                moduleBlockNoGroup[] {
                ...,
                _type == "gallery" => {
                    ...,
                    "imageUrl": images[].asset -> url
                },
                _type == "video" => {
                    "imageUrl": video_thumbnail_image.asset -> url
                },
                _type == "cc_img_section" => {
                    "imageUrl": cc_img.asset->url
                },
                _type == "cc_box_content" => {
                        "boxSectiontitle": cc_box_content_title,
                        "boxSectioncontent": cc_box_content_content,
                        "boxSectionwidth": cc_box_content_width,
                        "boxSectionalignment": cc_box_content_alignment,
                        "imageUrl": cc_box_content_images[].asset->url
                        },
                _type == "tutorial" => {
                    groups[] {
                    ...,
                    "imageUrl": tutorialGroup_img.asset -> url
                    }
                },
                }
            }
            }`).then((data) => {
                setLoadingHome(false); // Local loading complete
                // setTimeout(() => {
                    setLoading(false); // Add 400ms delay before setting global loading to false
                // }, 600);
            setHomeBlockData(data);
            setHeroDataLoaded(true);
        })
        .catch((error) => {
            console.error(error);
            setLoadingHome(false); // Make sure the loader dissapears even on error
            // setTimeout(() => {
                setLoading(false); // Add 400ms delay before setting global loading to false
            // }, 600);
        });
            // .catch(console.error);
            // setLoadingHome(false);
            //     setLoading(false);
    }, [setLoading])

    if (loadingHome  || !heroDataLoaded) {
        return <Loader />; // Use local loading state
    }

    return (
        <>
         {/* {loading && <Loader />} */}
            <Hero setHeroDataLoaded={setHeroDataLoaded}></Hero>
            {Array.isArray(homeBlockData) && homeBlockData.map((homeBlockDataItem, index) => {
                switch (homeBlockDataItem._type) {
                    case 'cc_title_section':
                        return <Title scrollTo={homeBlockDataItem.cc_ref_link_href}
                            title={homeBlockDataItem.cc_title_section_heading} subTitle={homeBlockDataItem.cc_title_section_title} />;
                    case 'modules':
                        switch (homeBlockDataItem.custom_module_blocks) {
                            case 'news_module':
                                return <Blog />;
                            case 'features_module':
                                return <Feature />;
                            case 'testimonials_module':
                                return <Testimonials />;
                            case 'prices_module':
                                return <Pricing />;
                            case 'teams_module':
                                return <TeamProfile />;
                            case 'contact_form_module':
                                return <Contact />;
                            default:
                                return null;
                        }
                    case 'reference':
                        return <About aboutData={homeBlockDataItem}></About>;
                    case 'cc_accordion':
                        return <Process data={homeBlockDataItem.groups} />;
                    case 'tutorial':
                        return <Tutorial data={homeBlockDataItem.groups} />;
                    case 'gallery':
                        return <Screenshots data={homeBlockDataItem.imageUrl} />;
                    case 'group':
                        return <Groups data={homeBlockDataItem.moduleBlockNoGroup} color={homeBlockDataItem.favoriteColor}/>;
                    case 'video':
                        return <Video data={homeBlockDataItem} />;
                    case 'cc_img_section':
                        return <ImageBlock data={homeBlockDataItem}></ImageBlock>;
                    case 'cc_breaker':
                        return <Breaker></Breaker>;
                    case 'cc_content_section':
                        return <ContentSection data={homeBlockDataItem}/>;
                    // case 'cc_box_content':
                    //     boxContentData.push(homeBlockDataItem);  
                    //     if (!renderedBoxContent) {
                    //         renderedBoxContent = true; // Set the flag to true so no further BoxContent is rendered
                    //         return <BoxContent key={index} data={boxContentData} />;
                    //     }
                    //     return null; 
                      case 'cc_box_content':                      
                        return <BoxContentNotGroup  data={homeBlockDataItem} />;
                    default:
                        return null;
                }
            })}
            {/* <CallToAction></CallToAction> */}
            {!loadingHome && <Footer footerData={footerData} items={items}></Footer>}
        </>
    );
}

export default Home;